import { Pipe, PipeTransform } from '@angular/core';
import { BuildingScanItemDto } from '@artemis-software/wr-api';
import ScanType = BuildingScanItemDto.TypeEnum;

@Pipe({
  standalone: false,
  name: 'scanType',
})
export class ScanTypePipe implements PipeTransform {
  transform(value: ScanType): string {
    switch (value) {
      case ScanType.PointCloud:
        return 'Punktwolken-Scan';
      case ScanType.Panorama:
        return 'Panorama-Scan';
    }
    return 'NAN';
  }
}
